import React, { useEffect, useState } from "react";

import {
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";

import {
  Table,
  Badge,
  Spinner,
  Card,
  Button,
  Row,
  Col,
  Modal,
  Form,
} from "react-bootstrap";

import api from "../components/Api";

const QuestionBankDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

 const isDemo =
  searchParams.get("is_demo") == "true" ||
  searchParams.get("is_demo") == "1";

  const [questions, setQuestions] = useState([]);

  const [loading, setLoading] = useState(true);

  const [showMediaModal, setShowMediaModal] =
    useState(false);

  const [selectedQuestion, setSelectedQuestion] =
    useState(null);

  const [mediaType, setMediaType] =
    useState("video");

  const [uploading, setUploading] =
    useState(false);

  const [mediaForm, setMediaForm] = useState({
    title: "",
    description: "",

    video_type: "url",
    video_url: "",
    video_file: null,

    ppt_type: "url",
    ppt_url: "",
    ppt_file: null,

    note_type: "url",
    note_url: "",
    note_file: null,
  });

  useEffect(() => {
    loadData();
  }, []);





const loadData = async () => {

  try {

    setLoading(true);

    const endpoint =
      `/pustak-questionbank/book/${id}?is_demo=${isDemo ? 1 : 0}`;

    console.log("ENDPOINT:", endpoint);

    const res = await api.get(endpoint);

    console.log("API RESPONSE:", res.data);

    if (
      res.data.status === true ||
      res.data.status === "success"
    ) {

      const formattedData = (res.data.data || []).map((item) => ({
        ...item,
        videos: item.videos || [],
        ppts: item.ppts || [],
        notes: item.notes || [],
      }));

      setQuestions(formattedData);

    } else {

      setQuestions([]);
    }

  } catch (err) {

    console.log("LOAD ERROR:", err);

    setQuestions([]);

  } finally {

    setLoading(false);
  }
};

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete question?"))
      return;

    try {
      const url = `/pustak-questionbank/delete/${id}?is_demo=${isDemo ? 1 : 0}`;

      const res = await api.delete(url);

      if (res.data.status === true) {
        alert("Deleted successfully");

        loadData();
      }
    } catch (err) {
      alert("Delete failed");
    }
  };

  // ================= OPEN MEDIA =================
  const openMediaModal = (question, type) => {
    setSelectedQuestion(question);

    setMediaType(type);

    setMediaForm({
      title: "",
      description: "",

      video_type: "url",
      video_url: "",
      video_file: null,

      ppt_type: "url",
      ppt_url: "",
      ppt_file: null,

      note_type: "url",
      note_url: "",
      note_file: null,
    });

    setShowMediaModal(true);
  };

  // ================= FORM CHANGE =================
  const handleMediaChange = (e) => {
    const { name, value } = e.target;

    setMediaForm({
      ...mediaForm,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setMediaForm({
      ...mediaForm,
      [name]: files[0],
    });
  };

  // ================= UPLOAD =================
  const handleMediaUpload = async () => {
    try {
      setUploading(true);

      const formData = new FormData();

      formData.append(
        "question_id",
        selectedQuestion?.id
      );

      formData.append(
        "isDemo",
        isDemo ? 1 : 0
      );

      formData.append(
        "title",
        mediaForm.title
      );

      formData.append(
        "description",
        mediaForm.description
      );

      // VIDEO
      if (mediaType === "video") {
        formData.append(
          "video_type",
          mediaForm.video_type
        );

        if (
          mediaForm.video_type === "url"
        ) {
          formData.append(
            "video_url",
            mediaForm.video_url
          );
        }

        if (
          mediaForm.video_type ===
            "upload" &&
          mediaForm.video_file
        ) {
          formData.append(
            "video_file",
            mediaForm.video_file
          );
        }

        await api.post(
          "/question-media/video/upload",
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );
      }

      // PPT
      if (mediaType === "ppt") {
        formData.append(
          "ppt_type",
          mediaForm.ppt_type
        );

        if (
          mediaForm.ppt_type === "url"
        ) {
          formData.append(
            "ppt_url",
            mediaForm.ppt_url
          );
        }

        if (
          mediaForm.ppt_type ===
            "upload" &&
          mediaForm.ppt_file
        ) {
          formData.append(
            "ppt_file",
            mediaForm.ppt_file
          );
        }

        await api.post(
          "/question-media/ppt/upload",
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );
      }


      {/* NOTES */}
// NOTES
if (mediaType === "note") {

  formData.append(
    "note_type",
    mediaForm.note_type
  );

  if (mediaForm.note_type === "url") {

    formData.append(
      "note_url",
      mediaForm.note_url
    );
  }

  if (
    mediaForm.note_type === "upload" &&
    mediaForm.note_file
  ) {

    formData.append(
      "note_file",
      mediaForm.note_file
    );
  }

  await api.post(
    "/question-media/note/upload",
    formData,
    {
      headers: {
        "Content-Type":
          "multipart/form-data",
      },
    }
  );
}

      alert("Uploaded successfully");

      setShowMediaModal(false);

      loadData();
    } catch (err) {
      console.log(err);

      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">

      {/* HEADER */}
      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body>

          <Row className="align-items-center">

            <Col>

              <h3 className="fw-bold mb-1">
                📘 Question Bank Details
              </h3>

              <p className="text-muted mb-0">
                Manage Questions, Videos & PPTs
              </p>

            </Col>

            <Col className="text-end">

              <Button
                variant="secondary"
                onClick={() =>
                  navigate(-1)
                }
              >
                ← Back
              </Button>

            </Col>

          </Row>

        </Card.Body>
      </Card>

      {/* TABLE */}
      <Card className="shadow-sm border-0 rounded-4">

        <Card.Body>

          <div className="table-responsive">

            <Table bordered hover>

              <thead className="table-dark">

                <tr>
                  <th>#</th>

                  <th>Question Bank</th>

                  <th>Type</th>

                  <th>Videos</th>

                  <th>PPTs</th>

                  <th>Notes</th>

                  <th width="400">
                    Actions
                  </th>
                </tr>

              </thead>

              <tbody>

                {questions.length > 0 ? (
                  questions.map((q, i) => (

                    <tr key={q.id}>

                      <td>{i + 1}</td>

                      <td>
                        <div className="fw-bold">
                          {q.bank_name}
                        </div>

                        <small className="text-muted">
                          {q.description}
                        </small>
                      </td>

                      <td>
                        <Badge bg="primary">
                          {q.questype}
                        </Badge>
                      </td>

                      <td>

                        {q.videos?.length >
                        0 ? (
                          q.videos.map((v) => (
                            <div
                              key={v.id}
                              className="mb-1"
                            >
                              🎥 {v.title}
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">
                            No Videos
                          </span>
                        )}

                      </td>

                      <td>

                        {q.ppts?.length >
                        0 ? (
                          q.ppts.map((p) => (
                            <div
                              key={p.id}
                              className="mb-1"
                            >
                              📊 {p.title}
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">
                            No PPT
                          </span>
                        )}

                      </td>

                      <td>
                        {q.notes?.length > 0 ? (
                            q.notes.map((n) => (
                            <div key={n.id} className="mb-1">
                                📝 {n.title}
                            </div>
                            ))
                        ) : (
                            <span className="text-muted">
                            No Notes
                            </span>
                        )}
                        </td>

                      <td>

                        <div className="d-flex flex-wrap gap-2">

                          {/* VIEW */}
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() =>
                              navigate(
                                `/dashboard/question-bank/view/${q.id}${
                                  isDemo
                                    ? "?demo=true"
                                    : ""
                                }`
                              )
                            }
                          >
                            👁 View 
                          </Button>

                          {/* EDIT */}
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() =>
                              navigate(
                                `/dashboard/question-bank/edit/${q.id}${
                                  isDemo
                                    ? "?demo=true"
                                    : ""
                                }`
                              )
                            }
                          >
                            ✏ Edit
                          </Button>

                          {/* VIDEO */}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() =>
                              openMediaModal(
                                q,
                                "video"
                              )
                            }
                          >
                            🎥 Video
                          </Button>

                          {/* PPT */}
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() =>
                              openMediaModal(
                                q,
                                "ppt"
                              )
                            }
                          >
                            📊 PPT
                          </Button>

                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() =>
                                openMediaModal(q, "note")
                            }
                            >
                            📝 Notes
                            </Button>

                          {/* DELETE */}
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() =>
                              handleDelete(
                                q.id
                              )
                            }
                          >
                            🗑 Delete
                          </Button>

                        </div>

                      </td>

                    </tr>

                  ))
                ) : (
                  <tr>

                    <td
                      colSpan="7"
                      className="text-center py-4"
                    >
                      No Questions Found
                    </td>

                  </tr>
                )}

              </tbody>

            </Table>

          </div>

        </Card.Body>

      </Card>

      {/* MEDIA MODAL */}
      <Modal
        show={showMediaModal}
        onHide={() =>
          setShowMediaModal(false)
        }
        centered
        size="lg"
      >
        <Modal.Header closeButton>

          <Modal.Title>

            {mediaType === "video"
              ? "🎥 Add Video"
              : "📊 Add PPT"}

          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

          <Form>

            <Form.Group className="mb-3">
              <Form.Label>
                Title
              </Form.Label>

              <Form.Control
                type="text"
                name="title"
                value={mediaForm.title}
                onChange={
                  handleMediaChange
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Description
              </Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={
                  mediaForm.description
                }
                onChange={
                  handleMediaChange
                }
              />
            </Form.Group>

            {/* VIDEO */}
            {mediaType ===
              "video" && (
              <>
                <Form.Select
                  name="video_type"
                  className="mb-3"
                  value={
                    mediaForm.video_type
                  }
                  onChange={
                    handleMediaChange
                  }
                >
                  <option value="url">
                    Youtube URL
                  </option>

                  <option value="upload">
                    Upload Video
                  </option>
                </Form.Select>

                {mediaForm.video_type ===
                "url" ? (
                  <Form.Control
                    className="mb-3"
                    type="text"
                    name="video_url"
                    placeholder="Youtube URL"
                    value={
                      mediaForm.video_url
                    }
                    onChange={
                      handleMediaChange
                    }
                  />
                ) : (
                  <Form.Control
                    className="mb-3"
                    type="file"
                    name="video_file"
                    accept="video/*"
                    onChange={
                      handleFileChange
                    }
                  />
                )}
              </>
            )}

            {/* PPT */}
            {mediaType === "ppt" && (
              <>
                <Form.Select
                  name="ppt_type"
                  className="mb-3"
                  value={
                    mediaForm.ppt_type
                  }
                  onChange={
                    handleMediaChange
                  }
                >
                  <option value="url">
                    PPT URL
                  </option>

                  <option value="upload">
                    Upload PPT
                  </option>
                </Form.Select>

                {mediaForm.ppt_type ===
                "url" ? (
                  <Form.Control
                    className="mb-3"
                    type="text"
                    name="ppt_url"
                    placeholder="PPT URL"
                    value={
                      mediaForm.ppt_url
                    }
                    onChange={
                      handleMediaChange
                    }
                  />
                ) : (
                  <Form.Control
                    className="mb-3"
                    type="file"
                    name="ppt_file"
                    accept=".ppt,.pptx,.pdf"
                    onChange={
                      handleFileChange
                    }
                  />
                )}
              </>
            )}


            {/* NOTES */}
{mediaType === "note" && (
  <>
    <Form.Select
      name="note_type"
      className="mb-3"
      value={mediaForm.note_type}
      onChange={handleMediaChange}
    >
      <option value="url">
        PDF URL
      </option>

      <option value="upload">
        Upload PDF
      </option>
    </Form.Select>

    {mediaForm.note_type === "url" ? (
      <Form.Control
        className="mb-3"
        type="text"
        name="note_url"
        placeholder="PDF URL"
        value={mediaForm.note_url}
        onChange={handleMediaChange}
      />
    ) : (
      <Form.Control
        className="mb-3"
        type="file"
        name="note_file"
        accept=".pdf"
        onChange={handleFileChange}
      />
    )}
  </>
)}

          </Form>

        </Modal.Body>

        <Modal.Footer>

          <Button
            variant="secondary"
            onClick={() =>
              setShowMediaModal(false)
            }
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={
              handleMediaUpload
            }
            disabled={uploading}
          >
            {uploading
              ? "Uploading..."
              : `Save ${mediaType.toUpperCase()}`}
          </Button>

        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default QuestionBankDetails;